<template>
  <div class="root-layout" :class="rootClass">
    <div class="header">
      <CommonHeader></CommonHeader>
      <div v-if="!layoutSetting.hiddenBackgroundImage" class="background-wrapper"></div>
    </div>
    <div class="body">
      <template v-if="layoutSetting.hiddenTabList">
        <slot>
          <router-view></router-view>
        </slot>
      </template>
      <template v-else>
        <div class="tab-list">
          <div class="tab-item-container">
            <div
              v-for="(item, index) in tabList"
              class="tab-item"
              :key="index"
              :ref="`tab-${index}`"
              :class="wrapperClass(item, index, activeTabIndex)"
              @click="handleClick(item, index)">
              <span>{{ item.meta.tab.label }}</span>
            </div>
          </div>
        </div>
        <div class="tab-content" :style="tabContentStyle">
          <slot>
            <router-view></router-view>
          </slot>
        </div>
      </template>
    </div>
    <div class="footer">
      <CommonFooter></CommonFooter>
      <div v-if="!layoutSetting.hiddenBackgroundImage" class="background-wrapper"></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import CommonFooter from '@/components/layout/footer/commonFooter.vue'
import CommonHeader from '@/components/layout/header/commonHeader.vue'
import { allLayoutRoutes } from '../route'
import '@/assets/scss/adaptWrapper.scss'

export default {
  metaInfo () {
    return {
      style: this.styleList
    }
  },
  components: {
    CommonFooter,
    CommonHeader
  },
  data () {
    return {
      tabList: [],
      activeTabIndex: null
    }
  },
  computed: {
    layoutSetting () {
      let route = this.$route
      let setting = null
      while (!setting && route) {
        setting = route.meta?.rootLayout
        route = route.meta?._parent
      }
      return setting || {}
    },
    styleList () {
      return [
        {
          vmid: 'commonStyle',
          innerHTML: `
            body {
              ${this.layoutSetting.hiddenBackgroundImage ? '' : `background: url(${process.env.VUE_APP_BASE_URL}static/images_en/bg.jpg?t=1) repeat;`}
              line-height: normal;
              font-family: Microsoft YaHei, "微软雅黑", Arial, Helvetica, sans-serif;
              font-size: 12px;
              color: #232323;
            }
            #main {
              min-width: 1100px;
              min-height: 100vh;
            }
            * {
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
            }
          `
        }
      ]
    },
    rootClass () {
      return [
        this.layoutSetting.hiddenBackgroundImage && 'hidden-background-image',
        this.layoutSetting.hiddenTabList && 'hidden-tab-list',
        this.layoutSetting.flexMode && 'flex-layout',
        this.layoutSetting.autosize && 'auto-size'
      ]
    },
    tabContentStyle () {
      const currentTabRoute = this.tabList[this.activeTabIndex]
      return currentTabRoute?.meta?.tab?.contentStyle || {}
    }
  },
  beforeCreate () {
    if (['tw', 'hk'].includes(this.$i18n.locale)) {
      this.$i18n.locale = 'zh'
    }
  },
  created () {
    // to-do move custom logic from backend web pages
    // now only support hr use
    const metaInfoList = [this.$route.meta]
    let metaInfo = this.$route.meta
    while ((metaInfo = metaInfo._parent?.meta)) {
      metaInfoList.push(metaInfo)
    }
    let tabIndex = 0
    const tabList = []
    _.forEach(allLayoutRoutes, (item) => {
      const hasPermission = this.hasAnyPermission(item.meta.permission)
      if (metaInfoList.includes(item.meta)) {
        this.activeTabIndex = tabIndex
        if (!hasPermission) {
          this.$router.replace('/error/no-permission')
          return false
        }
      }
      if (hasPermission) {
        tabIndex++
        tabList.push(item)
      }
    })
    this.tabList = tabList
    this.$nextTick(() => {
      this.setPreviousTabClass(true, this.activeTabIndex)
    })
  },
  methods: {
    handleClick (tabItem, index) {
      if (tabItem.meta.isInclude) {
        if (this.activeTabIndex === index) {
          this.reloadPage()
        } else {
          if (tabItem.path.includes(':')) {
            this.$router.push({ name: tabItem.name, params: this.$route.params })
          } else {
            this.$router.push(tabItem.path)
          }
          const before = this.activeTabIndex
          this.activeTabIndex = index
          this.$nextTick(() => {
            this.setPreviousTabClass(false, before)
            this.setPreviousTabClass(true, this.activeTabIndex)
          })
        }
      } else {
        let path = tabItem.path
        if (path.includes(':')) {
          _.forEach(this.$route.params, (val, key) => {
            path = path.replace(`:${key}`, val)
          })
        }
        window.location.href = path
      }
    },
    wrapperClass (tabItem, index, activeTabIndex) {
      const resultClasses = []
      const customClass = tabItem.meta.tab.customClass
      const customShowFunc = tabItem.meta.tab.customShowFunc
      if (customClass) {
        resultClasses.push(...customClass)
      }
      if (activeTabIndex === index) {
        resultClasses.push('is-active')
      }
      if (customShowFunc && typeof customShowFunc === 'function') {
        const isShow = customShowFunc(true, this.$route)
        if (!isShow) {
          resultClasses.push('is-disabled')
        }
      }
      return resultClasses
    },
    async setPreviousTabClass (isAdd, tabIndex) {
      if (tabIndex < 1 || this.layoutSetting.hiddenTabList) {
        return
      }
      let tabEls = this.$refs[`tab-${tabIndex - 1}`]
      if (!tabEls) {
        await this.$nextTick()
        tabEls = this.$refs[`tab-${tabIndex - 1}`]
      }
      const tabEl = tabEls[0]
      if (tabEl) {
        if (tabEl.classList.contains('is-disabled')) {
          this.setPreviousTabClass(isAdd, tabIndex - 1)
        } else {
          if (isAdd) {
            tabEl.classList.add('is-active-previous')
          } else {
            tabEl.classList.remove('is-active-previous')
          }
        }
      } else {
        this.setPreviousTabClass(isAdd, tabIndex - 1)
      }
    }
  },
  watch: {
    $route () {
      const metaInfoList = [this.$route.meta]
      let metaInfo = this.$route.meta
      while ((metaInfo = metaInfo._parent?.meta)) {
        metaInfoList.push(metaInfo)
      }
      this.setPreviousTabClass(false, this.activeTabIndex)
      this.activeTabIndex = _.findIndex(this.tabList, (item) => metaInfoList.includes(item.meta))
      this.$nextTick(() => {
        this.setPreviousTabClass(true, this.activeTabIndex)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.root-layout {
  min-height: 100%;

  ::v-deep * {
    box-sizing: border-box;
  }

  &.hidden-tab-list {
    min-width: 100%;

    .body {
      width: auto;
      margin: 0;
      padding: 40px 80px 10px;
    }
  }

  &.hidden-background-image {
    background-color: #FDFDF6;
  }

  &.flex-layout {
    display: flex;
    width: max-content;
    min-height: 100vh;
    flex-direction: column;

    .body {
      flex: 1;
      display: flex;
      justify-content: center;
    }
  }

  &.auto-size:not(.hidden-tab-list) {
    .body {
      width: 75%;
      max-width: 1440px;
      min-width: 980px;
    }
  }

  .header {
    position: relative;

    .background-wrapper {
      width: 100%;
      height: 330px;
      background: url($baseDomain + 'static/images_en/bgTop.jpg?t=1') repeat-x;
      position: absolute;
      top: 0;
      z-index: -1;
    }
  }

  .body {
    width: 980px;
    margin: auto;
    margin-top: 33px;

    .tab-list {
      height: 40px;
      margin: 0 20px;
      font-size: 12px;
      font-weight: bold;
      color: #fff;
      position: relative;

      .tab-item-container {
        .tab-item {
          display: inline-block;
          padding: 0 15px;
          height: 29px;
          margin-top: 11px;
          margin-right: 4px;
          line-height: 29px;
          background: #0296cc;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          text-align: center;
          vertical-align: bottom;
          cursor: pointer;

          &.is-disabled {
            display: none;
          }

          &.is-active-previous {
            margin-right: 0;
          }

          &.is-active {
            height: 32px;
            line-height: 34px;
            margin-right: -2px;
            margin-left: -7px;
            margin-top: 8px;
            background: #fff;
            color: #232323;
            position: relative;
          }

          &.search-candidate {
            background-image: url($baseDomain + 'static/image/icon_beta.png');
            background-repeat: no-repeat;
            background-position: right top;
          }
        }
      }
    }

    .tab-content {
      min-height: 540px;
      border-radius: 6px;
      background: #fff;
    }
  }

  .footer {
    position: relative;
    text-align: center;

    .background-wrapper {
      width: 100%;
      height: 320px;
      background: url($baseDomain + 'static/images_en/bgBottom.jpg?t=1') repeat-x;
      position: absolute;
      bottom: 0;
      z-index: -1;
    }
  }
}
.page-en {
  .root-layout {
    .body {
      .tab-list {
        .tab-item-container {
          .tab-item {
            padding: 0 10px;
          }
        }
      }
    }
  }
}
</style>
